import clsx from 'clsx';
import { forwardRef, Ref } from 'react';
import { Placement } from '@popperjs/core';
import { PopperColors } from './index';

interface ArrowProps extends BaseProps {
  color: PopperColors;
  placement: Placement;
  show: boolean;
}

function getArrowMargin(placement: Placement) {
  const [side, suffix] = placement.split('-');
  return `${getSidePlacement(side)} ${getPositionPlacement(side, suffix)}`;
}

function getPositionPlacement(side: string, suffix: string) {
  if (side === 'top' || side === 'bottom') {
    switch (suffix) {
      case 'start':
        return 'before:left-0 before:-translate-x-[.2rem]';
      case 'end':
        return 'before:right-0 before:-translate-x-[.2rem]';
      default:
        return 'before:-translate-x-[.2rem]';
    }
  }

  switch (suffix) {
    case 'start':
      return 'before:top-0 before:-translate-y-1';
    case 'end':
      return 'before:bottom-0 before:translate-y-1';
    default:
      return 'before:-translate-y-1';
  }
}

function getSidePlacement(side: string) {
  switch (side) {
    case 'bottom':
      return '-top-1';
    case 'left':
      return 'right-1';
    case 'right':
      return '-left-1';
    case 'top':
      return 'bottom-1';
  }
}

export const Arrow = forwardRef(
  (
    { color, placement, show, ...rest }: ArrowProps,
    ref: Ref<HTMLDivElement>
  ) => {
    const classes = useStyles();

    if (!show) return <div className="hidden" />;

    return (
      <div
        className={clsx(
          'before:absolute before:w-2 before:h-2 before:rotate-45',
          getArrowMargin(placement),
          classes.color[color]
        )}
        ref={ref}
        {...rest}
      />
    );
  }
);

const useStyles = () => ({
  color: {
    background: 'before:bg-background-light dark:before:bg-background-dark',
    card: 'before:bg-card-light dark:before:bg-card-dark',
    default: 'before:bg-[#616161]',
  },
});
